import React from "react";
import {connect} from 'dva';
import {framework_tool, component_tool} from '../../../../tool'

import {templateConfig, reduxTemplateConfig} from './config';

let {WizContainer, WizReduxTemplate} = framework_tool
let {WizBrowserExport, WizModal} = component_tool

const _getValue = (type, key) => {
  const values = {
    type: {
      //0: '取消关注',
      1: '否',//'关注',
      2: '是',//'互相关注'
    },
  }
  return values[type][key]
}

class ShortVideoPersonRelationManager extends WizContainer {
  componentName = 'shortVideoPersonRelationManager'

  constructor(props) {
    super(props);
    this.state = {}
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '关注人姓名',
        field: 'fullName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '关注人账号',
        field: 'userName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '被关注人姓名',
        field: 'relatedFullName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '被关注人账号',
        field: 'relatedUserName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '关注时间',
        field: 'relationTime',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '互相关注',
        field: 'type',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
    ]
    if (o['success']) {
      let data = o['data']
      data && data.forEach(e => {
        e['type'] =  _getValue('type', e['type'])
      })
      WizBrowserExport({
        title: '短视频关注信息',
        sheetName: '短视频关注信息',
        columns: columnDefs,
        rows: data,
        filename: '短视频关注信息.xlsx',
      })
      return true
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    let _reduxTemplateConfig = reduxTemplateConfig({
      templateConfig: templateConfig,
      apiDataFormat: {
        export: this._handleFile,
      }
    })
    return <WizReduxTemplate {..._reduxTemplateConfig}/>
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(ShortVideoPersonRelationManager);
